import dragon from './dragon_invite/en.json';
import exchangeShop from './exchange_shop/en.json';

export default {
    ...dragon,
    ...exchangeShop
};
